import React from "react";
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableWrapper,
  SimpleTableTitle,
  SimpleTableContainer,
  SimpleTableToolbar,
} from "cdk-radial";
import FilterBar from "./FilterBar";
import RoleRow from "./RoleRow";
import styled from "styled-components";

const RolesToolbar = styled(SimpleTableToolbar)`
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: rgba(21, 27, 37, 0.9) 0px -2px 0px inset;
`;

const RolesTableTitle = styled(SimpleTableTitle)`
  margin-left: 1rem;
  padding: 0.5rem 1rem 0px 0px;
  fontsize: 18px;
`;

const RolesTableContainer = styled(SimpleTableContainer)`
  max-height: 800px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const RolesTable = styled(SimpleTable)`
  position: relative;
  overflow: scroll;
`;

const RoleList = ({
  selectedRolesList,
  allRolesList,
  setDisplayedRolesList,
  sortByRoleName,
  globalDisable,
  displayedRolesList,
  handleCheckChange,
  canAssignRoles,
  noBorderRadius = false,
}) => {
  return (
    <SimpleTableWrapper
      style={noBorderRadius ? { borderRadius: 0 } : undefined}
    >
      <RolesToolbar
        style={{
          boxShadow: "rgba(21, 27, 37, 0.9) 0px -2px 0px inset",
        }}
      >
        <RolesTableTitle>Role List</RolesTableTitle>
        <>
          <FilterBar
            selectedList={selectedRolesList}
            allList={allRolesList}
            setDisplayedList={setDisplayedRolesList}
            sortFn={sortByRoleName}
            getFilterByAttribute={(item) => item.id}
            getSearchByAttribute={(item) => item.name}
          />
        </>
      </RolesToolbar>
      <RolesTableContainer>
        <RolesTable>
          <SimpleTableBody>
            {displayedRolesList.map((role) => (
              <RoleRow
                key={role.id}
                role={role}
                selectedRolesList={selectedRolesList}
                handleCheckChange={handleCheckChange}
                canAssignRoles={canAssignRoles}
                globalDisable={globalDisable}
                hasCheckboxes={true}
              />
            ))}
          </SimpleTableBody>
        </RolesTable>
      </RolesTableContainer>
    </SimpleTableWrapper>
  );
};

export default RoleList;
